import { createSelector } from 'reselect';

const makeSelectorInstance = selector => createSelector([selector], stateExtract => stateExtract);

export default makeSelectorInstance;
